import type {ReactElement} from 'react';
import {useContext} from 'react';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import {InfoBoxViewport} from '../../info-box-control.types';
import {CollapsibleInfoBox} from '../collapsible-info-box/collapsible-info-box';
import {InfoBox} from '../info-box/info-box';
import type {ConditionalInfoBoxProps} from './conditional-info-box.types';

export function ConditionalInfoBox({warning, rawValue, viewport}: ConditionalInfoBoxProps): ReactElement | null {
  const {state} = useContext(emailMakerContext);
  if (!warning || !isActiveViewport(viewport, state.editorViewport)) {
    return null;
  }

  return (
    <CollapsibleInfoBox isVisible={warning.isVisible(rawValue)} spacingClassName={getViewportSpacingClass(viewport)}>
      <InfoBox descriptor={warning} />
    </CollapsibleInfoBox>
  );
}

function isActiveViewport(viewport: InfoBoxViewport, editorViewport: EditorViewport): boolean {
  if (editorViewport === EditorViewport.MOBILE) {
    return viewport === InfoBoxViewport.MOBILE;
  }
  return viewport === InfoBoxViewport.DESKTOP;
}

function getViewportSpacingClass(viewport: InfoBoxViewport): string {
  if (viewport === InfoBoxViewport.MOBILE) {
    return 'spacing-m-b-2';
  }
  return 'spacing-m-t-2';
}
